import type { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';

import { CORREOS_PSICO } from '@leadsphere/types';

import { useAuth } from '../../hooks/useAuth.js';
import { getFirstAccessibleRoute } from './nav-config.js';

// Guard de ruta por persona (no por rol). Solo root o CORREOS_PSICO (Vero y Yael).
// Cualquier otro usuario autenticado es redirigido a su primera ruta accesible.
export function RequirePsicoAccess({ children }: { children: ReactNode }) {
  const { user } = useAuth();

  if (!user) {
    return <Navigate to="/login" replace />;
  }

  if (user.rol !== 'root' && !CORREOS_PSICO.includes(user.correo)) {
    return <Navigate to={getFirstAccessibleRoute(user.rol)} replace />;
  }

  return <>{children}</>;
}
